module.exports = __webpack_public_path__ + "static/media/support.4e6a575a.svg";